/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { PensionInsurance as PensionInsuranceType } from "../../../../types/ProcessCostSupport";
import { UseForm } from "../../../../types/UseForm";

type PensionInsuranceProps = {
  path: string;
  pensionInsurance: PensionInsuranceType;
  handleChange: UseForm["handleChange"];
};

const PensionInsurance = ({ path, pensionInsurance, handleChange }: PensionInsuranceProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Geben Sie hier bitte weitere Details zu der Versicherung an.
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".name"}
          label="Name der Versicherung"
          margin="normal"
          value={pensionInsurance.name}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".policyHolder"}
          label="Versicherungsnehmer"
          margin="normal"
          value={pensionInsurance.policyHolder}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".date"}
          label="Datum des Versicherungsvertrags"
          margin="normal"
          value={pensionInsurance.date}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".value"}
          label="Rückkaufswert"
          margin="normal"
          value={pensionInsurance.value}
          helperText={
            "Den aktuellen Rückkaufswert finden Sie in Ihrer jährlichen Übersicht, die Sie von der Versicherung erhalten, oder Sie erfragen den Wert bei Ihrem Versicherungsvertreter."
          }
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default PensionInsurance;
